import { render, staticRenderFns } from "./ListaParos.vue?vue&type=template&id=42f4d6c5&"
import script from "./ListaParos.vue?vue&type=script&lang=js&"
export * from "./ListaParos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports